import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgIconComponent } from "@ng-icons/core";
import { isNgIconName } from "../utils/icon";

/**
 * EVA Dashed Add Button — Bouton d'ajout avec bordure pointillée
 *
 * Bouton pleine largeur avec bordure dashed, utilisé pour les zones de création inline
 * (tâches, notes, conversations, etc.). Style harmonisé dans toute l'application.
 *
 * @example
 * // Usage minimal
 * <eva-dashed-add-button label="tâche" (buttonClick)="onCreate()" />
 *
 * // Avec icône personnalisée
 * <eva-dashed-add-button label="note" icon="pi-file-edit" (buttonClick)="onCreateNote()" />
 */
@Component({
  selector: "eva-dashed-add-button",
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  templateUrl: "./eva-dashed-add-button.component.html",
  styleUrls: ["./eva-dashed-add-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvaDashedAddButtonComponent {
  protected readonly isNgIconName = isNgIconName;

  /** Texte affiché après l'icône (ex: "tâche", "note", "conversation") */
  @Input() label: string = "";

  /** Nom ng-icon (ex: "heroPlus") ou classe PrimeIcons sans le préfixe "pi " (ex: "pi-file-edit") */
  @Input() icon: string = "heroPlus";

  /** Événement émis au clic sur le bouton */
  @Output() buttonClick = new EventEmitter<void>();
}
